import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import useStore from '@/utils/store/common';
import { IDevicesListState } from '@/store/modules/devices/types';
import ListLegend from '@/components/common/ListLegend/ListLegend.vue';
import DeviceDetails from './components/DeviceDetails/DeviceDetails.vue';
import DeviceInformations from './components/DeviceInformations/DeviceInformations.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DevicesListTable',
  props: {
  devicesListState: {
    type: Object,
    default: () => ({} as IDevicesListState)
  }
},
  setup(__props) {

const props = __props;



const store = useStore();

const getDevices = computed(() => store.getters['devices/getDevices']);

const isDevicesListLoading = computed(() => props.devicesListState.loading.devicesList);

const lastPositions: any = ref<{ [key: string]: any }>({});

const deviceListExpansionPanels = ref([] as any[]);

const mapDataLoaded = ref(false);

const legends = [
  'device.list.device_type',
  'device.word',
  'device.list.item.end_customer',
  'device.update.status',
  'device.list.item.vehicle',
  'device.list.last_connection'
];

const tableLegends = [''].concat(legends).concat('').map(legend => ({
  label: legend
}));

const legendsFlexStructure = ['0 0'].concat(legends.map(() => '1 1 0')).concat('0 0 130px');

function onDeviceSelect(deviceId: string) {
  store.dispatch('devices/userSelectionRegisterDevice', deviceId);
}

function isDeviceSelected(deviceId: string): boolean {
  return store.getters['devices/getUserSelectionDevices'].includes(deviceId);
}

watch(
  () => store.getters['devices/getNavigationConfiguration'].start,
  () => { deviceListExpansionPanels.value = []; }
);

watch(
  () => deviceListExpansionPanels.value,
  async (newvalues: number[], oldvalues: number[]) => {
    const open = newvalues.filter(v => !oldvalues.includes(v));
    const selectedDevice = getDevices.value.devicesList[open[0]] && getDevices.value.devicesList[open[0]].id ? getDevices.value.devicesList[open[0]].id : '';
    if (selectedDevice && open.length === 1 && !Object.keys(store.getters['devices/getDevicesListState']?.loading?.devicesHistory).includes(selectedDevice)) {
      mapDataLoaded.value = false;
      const id = open[0];
      const device = getDevices.value.devicesList[id];
      store.dispatch('devices/queryDevicesHistory', {
        size: 10,
        start: 0,
        deviceId: device.shortDeviceId,
        highPriority: true
      });
      const pos = await store.dispatch('devices/queryDevicesLastPositions', { deviceId: device.shortDeviceId });
      lastPositions.value[device.shortDeviceId] = pos;
      mapDataLoaded.value = true;
      if (!device.devicePersonalisationState?.currentPersonalisation?.isDeperso) {
        store.getters['personalisation/getInstanceNamesByDeviceID']({
          masterId: store.getters['user/getSelectedMasterAccount'].id,
          persoTargetId: device.devicePersonalisationState?.currentPersonalisation?.persoTargetID,
          persoTargetType: device.devicePersonalisationState?.currentPersonalisation?.persoTargetType
        });
        let concerned = '';
        if (device.type === 'obu5gen') {
          concerned = device.id || '';
        } else {
          concerned = device.devicePersonalisationState?.currentPersonalisation?.persoTargetID || '';
        }
        if (concerned) {
          store.dispatch('devices/queryDevicesTollDomainsNames', {
            persoTargetId: concerned,
            persoTargetType: device.devicePersonalisationState?.currentPersonalisation?.persoTargetType,
            masterId: store.getters['user/getSelectedMasterAccount'].id,
            subscriptions: device.devicePersonalisationState?.currentPersonalisation?.subscriptions
          });
        }
      }
    }
  },
  {
    deep: true,
    immediate: true
  }
);

return { __sfc: true,props, store, getDevices, isDevicesListLoading, lastPositions, deviceListExpansionPanels, mapDataLoaded, legends, tableLegends, legendsFlexStructure, onDeviceSelect, isDeviceSelected, ListLegend, DeviceDetails, DeviceInformations }
}

})